/**
 * NoteEdit Component
 *
 * @component
 * @description This component displays an interface for editing a note's content.
 * It provides a rich text editor with formatting toolbar for editing the note's content.
 *
 * @param {NoteEditProps} props - The properties and event handlers required by the component.
 * @returns {JSX.Element} - A JSX element representing the NoteEdit component.
 */
import React from 'react';
import RichTextEditor from './RichTextEditor';

interface NoteEditProps {
  noteContent: string;
  isDisabled?: boolean;
  handleOnChangeContentNote: (html: string) => void;
}

const NoteEdit = (props: NoteEditProps) => {
  const { noteContent, handleOnChangeContentNote, isDisabled } = props;

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        width: '100%',
      }}>
      <RichTextEditor
        content={noteContent}
        onChange={handleOnChangeContentNote}
        isDisabled={isDisabled}
        placeholder="Type your note here..."
      />
    </div>
  );
};

export default NoteEdit;
